import React from 'react';
import { Card, CardContent, Box, Skeleton, useTheme, Divider } from '@mui/material';

const OpportunityCardSkeleton: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Card elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
      <CardContent sx={{ p: 0 }}>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: theme.palette.grey[50] }}>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Box>
        <Divider />
        <Box sx={{ p: 2 }}>
          <Skeleton variant="rounded" height={80} sx={{ mb: 2 }} />
          <Skeleton variant="rounded" height={80} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default OpportunityCardSkeleton;